
const IdentityManage = () => import('@/vuepage/authority-manage/IdentityManage');
const HandleIdentity = () => import('@/vuepage/authority-manage/HandleIdentity');
const AdministratorList = () => import('@/vuepage/authority-manage/AdministratorList');
const HandleAdmin = () => import('@/vuepage/authority-manage/HandleAdmin');

export default [{
  path: '/admin-list',
  component: AdministratorList,
  meta: [{
    name: '权限管理'
  }, {
    name: '管理员列表',
    activeRoute: '/admin-list'
  }]
}, {
  path: '/add-admin',
  component: HandleAdmin,
  meta: [{
    name: '权限管理'
  }, {
    name: '管理员列表',
    url: '/admin-list'
  }, {
    name: '添加管理员',
    activeRoute: '/admin-list'
  }]
}, {
  path: '/edit-admin',
  component: HandleAdmin,
  meta: [{
    name: '权限管理'
  }, {
    name: '管理员列表',
    url: '/admin-list'
  }, {
    name: '编辑管理员',
    activeRoute: '/admin-list'
  }]
}, {
  path: '/role-manage',
  component: IdentityManage,
  meta: [{
    name: '权限管理'
  }, {
    name: '身份管理',
    activeRoute: '/role-manage'
  }]
}, {
  path: '/add-role',
  component: HandleIdentity,
  meta: [{
    name: '权限管理'
  }, {
    name: '身份管理',
    url: '/role-manage'
  }, {
    name: '添加身份',
    activeRoute: '/role-manage'
  }]
}, {
  path: '/edit-role',
  component: HandleIdentity,
  meta: [{
    name: '权限管理'
  }, {
    name: '身份管理',
    url: '/role-manage'
  }, {
    name: '编辑身份',
    activeRoute: '/role-manage'
  }]
}];